export const AdobeAnalytics = {
    get satelite() {
        return window?._satellite || false;
    },
    get config() {
        return {
            ch: 'OADC',
            prop3: window.location.host,
            prop5: 'eng',
            prop16: window.location.host + window.location.pathname,
            prop41: 'SVI Interactive Map',
            prop8: 'App'
        };
    },
    sendPageView(str) {
        const _satellite = this.satelite;
        if (!_satellite) return;

        var dataObject = this.config;
        dataObject.pageName = str;
        dataObject.prop2 = str;

        _satellite.track('pageview', dataObject);
    },
    sendInteraction(eventLabel, eventValue) {
        const _satellite = this.satelite;
        if (!_satellite) return;

        var dataObject = this.config;
        dataObject.pageName = document.title;
        dataObject.label = eventLabel;
        dataObject.interactionType = 'o';
        dataObject.interactionValue = eventValue;
        // console.log('track this...', dataObject);
        _satellite.track('interaction', dataObject);

        // var dataObject = {};
        // var eventType = 'o';
        // dataObject.ch = 'OADC';
        // dataObject.pageName = document.title;
        // dataObject.label = eventLabel;
        // dataObject.interactionType = eventType;
        // dataObject.interactionValue = 'ci-' + eventLabel + ': ' + eventValue;

        // console.log('track this...', dataObject);
        // _satellite.track('interaction', dataObject);
    }
};
